import React from 'react';
import { connect } from 'react-redux';
import SoftwareComponent from '@/containers/CampaignDetail/Software/Software';
import Notes from '@/containers/SubCampaignDetail/Notes/Notes';
import { TABS } from '@/helpers/constants';
import { getIsVANCR } from '@/redux/Campaign/campaign.reducer';
import { setSubCampaignSoftwareNotes, setSubCampaignOriginalValues } from '@/redux/SubCampaign/subCampaign.action';
import { getSubcampaignSoftwareNotes, getSubCampaignOriginalValues } from '@/redux/SubCampaign/subCampaign.reducer';
import { OriginalValues } from '@/types';

interface SoftwareProps {
  setSoftwareNotes: (notes: string[]) => void;
  softwareNotes: string[];
  setOriginalValues: (values: OriginalValues) => void;
  originalValues: OriginalValues;
  isVANCR: boolean;
}

const Software = (props: SoftwareProps) => {
  const { setSoftwareNotes, softwareNotes, setOriginalValues, originalValues, isVANCR } = props;

  const onSetOriginValues = () => {
    const values = {
      ...originalValues,
      hasChange: true,
    };
    setOriginalValues(values);
  };

  const addNotes = () => {
    setSoftwareNotes([...softwareNotes, '']);
  };

  const handleChangeText = (comment: string, id: number) => {
    const newState = [...softwareNotes];
    newState.splice(id, 1, comment);
    setSoftwareNotes(newState);
    onSetOriginValues();
  };

  return (
    <>
      <SoftwareComponent subCR />
      {!isVANCR && (<Notes notes={softwareNotes} addNotes={addNotes} handleChangeText={handleChangeText} tab={TABS.affectedSoftware.label} />)}
    </>
  );
};

const mapStateToProps = (state) => ({
  softwareNotes: getSubcampaignSoftwareNotes(state),
  originalValues: getSubCampaignOriginalValues(state),
  isVANCR: getIsVANCR(state),
});

const actionCreators = {
  setSoftwareNotes: setSubCampaignSoftwareNotes,
  setOriginalValues: setSubCampaignOriginalValues,
};

export default connect(mapStateToProps, actionCreators)(Software);
